import React from "react";

// Dropdown
import { DropDown as DropDownContext } from "core/DropDown/index.js";

// components
import LinkDropDown from "core/SiteHeader/components/LinkDropDown";

// data
import { primaryMenu } from "data/links";
const {
    about,
    blog,
    submitIcons,
    submitPhotos,
    customerSupport
} = primaryMenu.tnp.links;

// component
const DropDown = () => {
    return (
        <DropDownContext>
            <LinkDropDown link={about} />
            <LinkDropDown link={blog} />
            <LinkDropDown link={submitIcons} />
            <LinkDropDown link={submitPhotos} />
            <LinkDropDown link={customerSupport} />
        </DropDownContext>
    );
};

export default DropDown;
